import { H5 } from "@sellar-io/components";
import { ReactElement, useState } from "react";
import { usePriceTierList } from "../../../../hooks/api/v2/priceTier/usePriceTierList";
import { useSellarCurrentBusiness } from "../../../../hooks/useSellarCurrentBusiness.shared";

import { InfiniteList } from "../../../infiniteLoading/InfiniteList";
import { ListElement } from "../../../list/ListElement";
import { DialogContent, DialogPage } from "../../../modal/Dialog";
import { useFullPageDialogContext } from "../../../modal/useFullPageDialogContext";
import { SpinnerLegacy } from "../../..";
import { ToastProvider } from "../../../toast/useToast";
import { SharePricingDialogDeactivatePage } from "./SharePricingDialogDeactivatePage";
import { SharePricingDialogStorefrontLink } from "./SharePricingDialogStorefrontLink";
import {
  SharePricingDialogPage,
  SharePricingSource,
} from "./SharePricingDialogTypes";

export function SharePricingDialogContent({
  optionalPriceTierId,
  setPriceTierName,
  source,
}: {
  optionalPriceTierId?: number;
  setPriceTierName: (name: string) => void;
  source: SharePricingSource;
}): ReactElement {
  const { business } = useSellarCurrentBusiness();
  const { setPage } = useFullPageDialogContext();

  const [priceTierId, setPriceTierId] = useState<number | undefined>(
    optionalPriceTierId,
  );

  const priceTiersListQuery = usePriceTierList(
    {
      limit: 6,
    },
    { enabled: !!business?.Supplier },
  );

  return (
    <>
      {priceTiersListQuery.isLoading ? (
        <SpinnerLegacy />
      ) : !priceTiersListQuery.data?.pages[0]?.[0] ? (
        <div>No price tiers found</div>
      ) : (
        <>
          <DialogPage page={SharePricingDialogPage.PRICE_TIERS}>
            <DialogContent>
              <InfiniteList
                query={priceTiersListQuery}
                className={"divide-y rounded-lg border border-solid"}
              >
                {priceTiersListQuery.data.pages.map((page) =>
                  page.map((priceTier) => (
                    <ListElement
                      key={priceTier.id}
                      className={"p-4"}
                      onClick={() => {
                        setPriceTierId(priceTier.id);
                        setPriceTierName(priceTier.name);
                        setPage(SharePricingDialogPage.PRICE_TIER_LINK);
                      }}
                    >
                      <div>
                        <H5>{priceTier.name}</H5>
                      </div>
                    </ListElement>
                  )),
                )}
              </InfiniteList>
            </DialogContent>
          </DialogPage>
          <ToastProvider>
            <DialogPage page={SharePricingDialogPage.PRICE_TIER_LINK}>
              {priceTierId && (
                <SharePricingDialogStorefrontLink
                  priceTierId={priceTierId}
                  source={source}
                />
              )}
            </DialogPage>
          </ToastProvider>
          <DialogPage page={SharePricingDialogPage.PRICE_TIER_LINK_DEACTIVATE}>
            {priceTierId && (
              <SharePricingDialogDeactivatePage
                priceTierId={priceTierId}
                source={source}
              />
            )}
          </DialogPage>
        </>
      )}
    </>
  );
}
